// Storage do access token. Estrategia espelhada do vanilla
// (apps/web/js/api-client.js): sessionStorage por aba + cache in-memory.
// O refresh token vive em cookie httpOnly (frotas_refresh) gerenciado pelo
// backend, fora do alcance do JS.

const STORAGE_KEY = 'just-frotas:access_token';

let inMemoryToken: string | null = null;

export const authStorage = {
  getToken(): string | null {
    if (inMemoryToken) return inMemoryToken;
    try {
      const stored = window.sessionStorage.getItem(STORAGE_KEY);
      if (stored) inMemoryToken = stored;
      return stored;
    } catch {
      return null;
    }
  },
  setToken(token: string): void {
    inMemoryToken = token;
    try {
      window.sessionStorage.setItem(STORAGE_KEY, token);
    } catch {
      /* sessionStorage indisponivel: cache in-memory ainda funciona ate reload */
    }
  },
  clearToken(): void {
    inMemoryToken = null;
    try {
      window.sessionStorage.removeItem(STORAGE_KEY);
    } catch {
      /* */
    }
  },
};
